/* Component Dependencies */
var imageHeaderTextCtaTemplate = require('templates/imageHeaderTextCta.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'imageHeaderTextCta',
  template: {
    'imageHeaderTextCta': imageHeaderTextCtaTemplate
  },
  bindEvents: function() {
    var _self = this;
    _self.registerPopup();
  },
  registerPopup: function() {
    this.learnMorePopup = new Popup({
      selector: '.tile-image-header-text-cta .mi-popover',
      sourceBlock: '.modal-content',
      addClassOnmfpWrap: true
    });
    this.learnMorePopup.register();
  }
});
